/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
export type ChevronIcons = 'chevron-left' | 'chevron-right' | 'chevron-down';
export type NavigationIcons =
  | 'dashboard'
  | 'parking'
  | 'parking-history'
  | 'control-history'
  | 'people'
  | 'docs'
  | 'administrators'
  | 'logout';
export type Icon =
  | 'hamburger'
  | 'close'
  | 'tooltip'
  | 'closed-letter'
  | 'phone'
  | 'trash'
  | 'device'
  | 'cellphone'
  | 'dots-vertical'
  | NavigationIcons
  | ChevronIcons;

export const ICONS_MAP_icon = new Map<Icon, string>([
  [
    'hamburger',
    `
    <svg viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1H24M0 9.06667H24M0 17.5H24" stroke="currentColor" stroke-width="2"/>
    </svg>
    `,
  ],
  [
    'close',
    `
    <svg viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.3556 25.6058L9.38559 8.63487M9.38531 25.6056L26.3559 8.63508" stroke="currentColor" stroke-width="2"/>
    </svg>
    `,
  ],
  [
    'logout',
    `
    <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0H6V6H8V0Z" fill="currentColor"/>
      <path d="M11.7 3.8C11.3 3.4 10.7 3.5 10.3 3.9C9.9 4.3 10 4.9 10.4 5.3C11.4 6.2 12 7.6 12 9C12 11.8 9.8 14 7 14C4.2 14 2 11.8 2 9C2 7.6 2.6 6.2 3.7 5.3C4.1 4.9 4.1 4.3 3.8 3.9C3.4 3.5 2.8 3.5 2.4 3.8C0.9 5.1 0 7 0 9C0 12.9 3.1 16 7 16C10.9 16 14 12.9 14 9C14 7 13.2 5.1 11.7 3.8Z" fill="currentColor"/>
    </svg>

    `,
  ],
  [
    'dashboard',
    `
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9H1C0.448 9 0 8.552 0 8V1C0 0.448 0.448 0 1 0H6C6.552 0 7 0.448 7 1V8C7 8.552 6.552 9 6 9Z" fill="currentColor"/>
      <path d="M6 16H1C0.448 16 0 15.552 0 15V12C0 11.448 0.448 11 1 11H6C6.552 11 7 11.448 7 12V15C7 15.552 6.552 16 6 16Z" fill="currentColor"/>
      <path d="M15 6H10C9.448 6 9 5.552 9 5V1C9 0.448 9.448 0 10 0H15C15.552 0 16 0.448 16 1V5C16 5.552 15.552 6 15 6Z" fill="currentColor"/>
      <path d="M15 16H10C9.448 16 9 15.552 9 15V9C9 8.448 9.448 8 10 8H15C15.552 8 16 8.448 16 9V15C16 15.552 15.552 16 15 16Z" fill="currentColor"/>
    </svg>

    `,
  ],
  [
    `parking`,
    `
    <svg viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.51119 0.0146173C3.89401 -0.263526 0 3.4636 0 8.1364C0 9.74963 0.445029 11.196 1.22383 12.4754C1.5576 13.0317 2.16952 13.3655 2.83706 13.3655H13.184C13.8515 13.3655 14.4635 13.0317 14.7972 12.4754C15.6873 11.0291 16.1323 9.24898 15.9654 7.41323C15.6317 3.46359 12.4052 0.237132 8.51119 0.0146173ZM13.6848 7.91455C13.4087 7.91455 13.1848 8.13841 13.1848 8.41455C13.1848 8.69069 13.4087 8.91455 13.6848 8.91455H14.2967C14.5729 8.91455 14.7967 8.69069 14.7967 8.41455C14.7967 8.13841 14.5729 7.91455 14.2967 7.91455H13.6848ZM13.0011 3.40952C13.1845 3.61591 13.1659 3.93195 12.9595 4.1154L12.4589 4.56043C12.2525 4.74389 11.9365 4.7253 11.753 4.51891C11.5695 4.31252 11.5881 3.99648 11.7945 3.81302L12.2952 3.36799C12.5016 3.18454 12.8176 3.20313 13.0011 3.40952ZM8.5105 1.73914C8.5105 1.46299 8.28664 1.23914 8.0105 1.23914C7.73436 1.23914 7.5105 1.46299 7.5105 1.73914V2.35105C7.5105 2.62719 7.73436 2.85105 8.0105 2.85105C8.28664 2.85105 8.5105 2.62719 8.5105 2.35105V1.73914ZM2.98409 3.38815C3.17936 3.19288 3.49594 3.19288 3.6912 3.38815L4.13623 3.83318C4.33149 4.02844 4.33149 4.34502 4.13623 4.54028C3.94097 4.73554 3.62438 4.73554 3.42912 4.54028L2.98409 4.09525C2.78883 3.89999 2.78883 3.58341 2.98409 3.38815ZM1.72461 7.91455C1.44847 7.91455 1.22461 8.13841 1.22461 8.41455C1.22461 8.69069 1.44847 8.91455 1.72461 8.91455H2.39215C2.6683 8.91455 2.89215 8.69069 2.89215 8.41455C2.89215 8.13841 2.6683 7.91455 2.39215 7.91455H1.72461ZM8.84492 10.9179C8.39989 11.3629 7.67672 11.3629 7.17606 10.9179C6.73103 10.4729 6.73103 9.69408 7.17606 9.24905C7.50491 8.92021 7.98563 8.83436 8.41622 8.99151C8.43613 8.95843 8.4602 8.92714 8.48846 8.89841L11.7705 5.56069C11.9642 5.36379 12.2807 5.36113 12.4776 5.55474C12.6745 5.74836 12.6772 6.06493 12.4836 6.26182L9.20148 9.59955C9.17395 9.62755 9.14393 9.65162 9.11212 9.67176C9.25587 10.0773 9.16681 10.5558 8.84492 10.9179Z" fill="currentColor"/>
    </svg>

    `,
  ],
  [
    'parking-history',
    `
    <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2642 15.4574C13.2642 15.7287 13.0115 16 12.6325 16H0.631627C0.315813 16 0 15.7287 0 15.4574V0.80707C0 0.535768 0.252651 0.264465 0.631627 0.264465H10.1058V2.97749H13.2639L10.1058 0.264465H10.106C10.2955 0.264465 10.3587 0.318726 10.485 0.427247L13.0747 2.65193C13.201 2.76045 13.2642 2.86897 13.2642 2.97749V15.4574ZM3.15792 12.9226C2.88178 12.9226 2.65792 13.1465 2.65792 13.4226C2.65792 13.6987 2.88178 13.9226 3.15792 13.9226H10.0427C10.3188 13.9226 10.5427 13.6987 10.5427 13.4226C10.5427 13.1465 10.3188 12.9226 10.0427 12.9226H3.15792ZM3.5 7V3H4.5V6.5H6.5H8.5V3H9.5V7V11H8.5V7.5H6.5H4.5V11H3.5V7Z" fill="currentColor"/>
    </svg>
  `,
  ],
  [
    'control-history',
    `
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3448 16H1.65517C0.717241 16 0 15.2828 0 14.3448V1.65517C0 0.717241 0.717241 0 1.65517 0H14.3448C15.2828 0 16 0.717241 16 1.65517V14.3448C16 15.2828 15.2828 16 14.3448 16ZM7.16891 8.27586C7.16891 7.99972 7.39277 7.77586 7.66891 7.77586H12.4689C12.7451 7.77586 12.9689 7.99972 12.9689 8.27586C12.9689 8.552 12.7451 8.77586 12.4689 8.77586H7.66891C7.39277 8.77586 7.16891 8.552 7.16891 8.27586ZM4.9104 8.27585C4.9104 8.8548 4.44107 9.32412 3.86212 9.32412C3.28318 9.32412 2.81385 8.8548 2.81385 8.27585C2.81385 7.6969 3.28318 7.22757 3.86212 7.22757C4.44107 7.22757 4.9104 7.6969 4.9104 8.27585ZM7.16891 12.1379C7.16891 11.8618 7.39277 11.6379 7.66891 11.6379H12.4689C12.7451 11.6379 12.9689 11.8618 12.9689 12.1379C12.9689 12.4141 12.7451 12.6379 12.4689 12.6379H7.66891C7.39277 12.6379 7.16891 12.4141 7.16891 12.1379ZM4.9104 12.1379C4.9104 12.7169 4.44107 13.1862 3.86212 13.1862C3.28318 13.1862 2.81385 12.7169 2.81385 12.1379C2.81385 11.559 3.28318 11.0896 3.86212 11.0896C4.44107 11.0896 4.9104 11.559 4.9104 12.1379ZM7.16891 4.41379C7.16891 4.13765 7.39277 3.91379 7.66891 3.91379H12.4689C12.7451 3.91379 12.9689 4.13765 12.9689 4.41379C12.9689 4.68994 12.7451 4.91379 12.4689 4.91379H7.66891C7.39277 4.91379 7.16891 4.68994 7.16891 4.41379ZM4.9104 4.41378C4.9104 4.99273 4.44107 5.46206 3.86212 5.46206C3.28318 5.46206 2.81385 4.99273 2.81385 4.41378C2.81385 3.83483 3.28318 3.3655 3.86212 3.3655C4.44107 3.3655 4.9104 3.83483 4.9104 4.41378Z" fill="currentColor"/>
    </svg>

    `,
  ],
  [
    'people',
    `
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
        <path d="M11.3743 12.078C9.14796 11.1735 6.64337 10.0604 6.43466 9.36468V8.59939C6.92166 8.11238 7.26952 7.41666 7.47824 6.5818C7.96524 6.16437 8.10438 5.39908 7.68695 4.8425V3.24234C7.68695 1.57262 6.78252 0.389893 4.69536 0.389893C2.67777 0.389893 1.70376 1.57262 1.70376 3.24234V4.91207C1.3559 5.46865 1.49505 6.23394 1.98205 6.65137C2.19077 7.48624 2.53863 8.18195 3.02563 8.66896V9.43425C2.81691 10.13 0.312322 11.2431 -1.91398 12.1476C-2.1227 12.2171 -2.26184 12.4258 -2.26184 12.6346V14.4434C-2.26184 14.7217 -2.05312 15 -1.77484 15H11.1656C11.4438 15 11.6526 14.7913 11.6526 14.4434V12.565C11.7221 12.3563 11.583 12.1476 11.3743 12.078Z" fill="currentColor"/>
        <path d="M18.0253 12.7041C16.2465 11.9935 14.2455 11.1189 14.0787 10.5722V9.97095C14.4678 9.5883 14.7457 9.04166 14.9125 8.3857C15.3016 8.05772 15.4128 7.45642 15.0793 7.01911V5.76184C15.0793 4.44991 14.3566 3.52063 12.6891 3.52063C11.0771 3.52063 10.2989 4.44991 10.2989 5.76184V7.07377C10.021 7.51108 10.1322 8.11238 10.5213 8.44036C10.688 9.09633 10.9659 9.64296 11.355 10.0256V10.6269C11.2934 10.8291 11.0687 10.9065 10.6093 11.1735C10.6093 11.1735 12.3485 11.7371 12.3485 12.2171C12.3485 12.3911 12.3485 13.0967 12.3485 13.2607V13.9564C12.3485 14.1751 12.3485 14.6521 12.3485 14.6521V15H17.8585C18.0809 15 18.2476 14.836 18.2476 14.5627V13.0868C18.3032 12.9228 18.192 12.7588 18.0253 12.7041Z" fill="currentColor"/>
      </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
    </svg>

    `,
  ],
  [
    'docs',
    `
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.0933 1.81333H4.2666C4.2666 1.81333 3.6266 0.266663 3.3066 0.266663H0.906602C0.533268 0.266663 0.266602 0.533329 0.266602 0.853329V13.9733C0.266602 14.3467 0.533268 14.6667 0.906602 14.6667H15.0933C15.4666 14.6667 15.7333 14.4 15.7333 13.9733V2.45333C15.7333 2.13333 15.4133 1.81333 15.0933 1.81333Z" fill="currentColor"/>
      <path d="M15.7333 4.58667H0.266602" stroke="white" stroke-miterlimit="10"/>
    </svg>

    `,
  ],
  [
    'chevron-left',
    `
    <svg viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 1L1 8L8 15" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    `,
  ],
  [
    'chevron-right',
    `
    <svg viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 15L8 8L0.999999 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    `,
  ],
  [
    'chevron-down',
    `
    <svg viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L8 8L15 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    `,
  ],
  [
    'tooltip',
    `
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM9 12H7V7H9V12ZM8 6C7.4 6 7 5.6 7 5C7 4.4 7.4 4 8 4C8.6 4 9 4.4 9 5C9 5.6 8.6 6 8 6Z" fill="currentColor"/>
    </svg>

    `,
  ],
  [
    'closed-letter',
    `
    <svg  viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.2681 2.86304L9.59896 7.68495C9.14543 8.06852 8.46513 8.06852 8.0683 7.68495L2.39917 2.86304" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.47 8.17798L15.2683 11.1369" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.19748 8.17798L2.39917 11.1369" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M0.69873 2.80817V11.1917C0.69873 12.0684 1.43572 12.726 2.34278 12.726H15.3818C16.3455 12.726 17.0825 12.0137 17.0825 11.1917V2.80817C17.0825 1.93146 16.3455 1.27393 15.3818 1.27393H2.34278C1.43572 1.27393 0.69873 1.98625 0.69873 2.80817Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    `,
  ],

  [
    'phone',
    `
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.3458 7.90061C10.2509 7.80608 10.061 7.80608 9.91867 7.90061C9.91867 7.90061 9.11191 8.7041 9.01699 8.75137L8.96954 8.79863C8.11531 9.22401 4.98315 5.9155 5.60009 5.30106L6.50177 4.4503C6.59669 4.35578 6.59669 4.16672 6.50177 4.02492L3.65436 1.09453C3.6069 1.04726 3.51199 1 3.41707 1C3.32216 1 3.2747 1.04726 3.22724 1.09453C1.75608 2.51246 -0.569313 3.9304 4.88824 9.46034C10.2509 14.8957 11.7695 12.8634 13.2881 11.2564C13.383 11.1619 13.383 10.9728 13.2881 10.8783L10.3458 7.90061Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    `,
  ],
  [
    'trash',
    `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14" fill="none">
      <path d="M10.4642 13.0003H2.7771L2.07451 2.64062H11.1668L10.4642 13.0003Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1 2.64062H12.2414" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.77792 1H5.46352L4.92625 2.64029H8.3152L7.77792 1Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.62067 4.32373V11.2734" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.01782 4.32373L8.5632 11.2734" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.26498 4.32373L4.71959 11.2734" stroke="#currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    `,
  ],
  [
    'cellphone',
    `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 22" fill="none">
      <path d="M11.2093 3.7619H4.14917L3.81215 1.82325C3.77724 1.59366 3.66127 1.38427 3.48535 1.23318C3.30942 1.08209 3.08524 0.99935 2.85359 1.00001H1.96685C1.71195 0.998723 1.46695 1.09891 1.28567 1.27858C1.10439 1.45825 1.00164 1.7027 1 1.95826V20.2162C1.00128 20.4253 1.08529 20.6252 1.23356 20.7722C1.38183 20.9192 1.58224 21.0011 1.79075 21H11.2093C11.4178 21.0011 11.6182 20.9192 11.7664 20.7722C11.9147 20.6252 11.9987 20.4253 12 20.2162V4.54498C11.9985 4.33606 11.9145 4.13627 11.7662 3.98945C11.6179 3.84263 11.4176 3.76079 11.2093 3.7619V3.7619Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.04285 14.125H3.99519" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.01941 14.125H6.97245" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.99585 14.125H9.94889" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.04285 16.2021H3.99519" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.01941 16.2021H6.97245" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.99585 16.2021H9.94889" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.04285 18.2793H3.99519" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.01941 18.2793H6.97245" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.99585 18.2793H9.94889" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.25832 5.81641H3.73345C3.35204 5.81641 3.04285 6.12639 3.04285 6.50878V10.663C3.04285 11.0454 3.35204 11.3554 3.73345 11.3554H9.25832C9.63973 11.3554 9.94893 11.0454 9.94893 10.663V6.50878C9.94893 6.12639 9.63973 5.81641 9.25832 5.81641Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    `,
  ],
  [
    'device',
    `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 22" fill="none">
      <path d="M6.56192 9.50018C6.56192 9.77624 6.47172 10.0461 6.30275 10.2756C6.13377 10.5052 5.89359 10.6841 5.6126 10.7897C5.33161 10.8953 5.02243 10.9229 4.72416 10.869C4.42589 10.8151 4.15193 10.6821 3.93693 10.4868C3.72194 10.2916 3.57556 10.0428 3.51632 9.77204C3.45708 9.50125 3.48764 9.22061 3.60413 8.96559C3.72061 8.71058 3.9178 8.49265 4.17075 8.33937C4.42369 8.18609 4.72103 8.10436 5.02516 8.10449C5.4328 8.10468 5.82368 8.2518 6.11186 8.51352C6.40003 8.77524 6.56192 9.13014 6.56192 9.50018Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.8469 4.22638C6.61083 3.99628 6.32509 3.81277 6.00748 3.6873C5.68987 3.56183 5.34719 3.49707 5.0008 3.49707C4.65442 3.49707 4.31174 3.56183 3.99413 3.6873C3.67652 3.81277 3.39078 3.99628 3.15471 4.22638" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 2.55458C8.48381 2.06329 7.86315 1.6722 7.1756 1.40499C6.48805 1.13778 5.74791 1 5 1C4.25209 1 3.51195 1.13778 2.8244 1.40499C2.13685 1.6722 1.51619 2.06329 1 2.55458" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.45287 6.47607H1.59573V21H8.45287V6.47607Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    `,
  ],
  [
    'dots-vertical',
    `
    <svg viewBox="0 0 4 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2" r="2" fill="currentColor"/>
      <circle cx="2" cy="10" r="2" fill="currentColor"/>
    </svg>

    `,
  ],
  [
    'administrators',
    `
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.84623 10.0067C9.89974 9.9532 9.84623 8.98999 9.84623 8.88296C10.4884 8.24082 10.97 7.27761 11.0235 6.36791C11.6656 6.36791 11.8797 5.45821 11.291 5.13714C11.3981 4.76256 11.4516 4.33447 11.4516 3.95989C11.4516 1.92644 9.89974 0.267578 7.97332 0.267578C6.0469 0.267578 4.49506 1.92644 4.49506 3.95989C4.49506 4.38798 4.54857 4.76256 4.7091 5.13714C4.12048 5.4047 4.33452 6.36791 4.97666 6.36791C5.03017 7.27761 5.45827 8.24082 6.10041 8.88296C6.10041 8.98999 6.10041 9.9532 6.10041 10.0067" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.53516 15.7857H13.5184C14.623 15.7857 15.5184 14.8903 15.5184 13.7857V13.5952C15.5184 12.811 15.06 12.0991 14.346 11.7745L10.0265 9.8111C9.76662 9.69296 9.48443 9.63184 9.19893 9.63184H6.85466C6.56916 9.63184 6.28697 9.69296 6.02706 9.8111L1.70755 11.7745C0.993561 12.0991 0.535156 12.811 0.535156 13.5952V13.7857C0.535156 14.8903 1.43059 15.7857 2.53516 15.7857ZM7.16667 15.7817L7.5 13.3158V12.8947L7 11.6316L7.16667 11H8.83333L9 11.6316L8.5 12.8947V13.3158L8.77629 15.7817H7.16667Z" fill="currentColor"/>
    </svg>

    `,
  ],
]);
